var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRequestItem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.722,
    height: 22.161,
    viewBox: "0 0 20.722 22.161",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M.768,3.824A.455.455,0,0,0,.9,3.781q.064-.032.118-.064L8.921-.752a3.283,3.283,0,0,0,1.106-.94A2.837,2.837,0,0,0,10.4-3.319v-8.035a2.919,2.919,0,0,0-.075-.72L.768-6.649Zm-1.45,0V-6.649l-9.561-5.425a2.919,2.919,0,0,0-.075.72v8.035a2.837,2.837,0,0,0,.376,1.627,3.283,3.283,0,0,0,1.106.94L-.929,3.717a1.3,1.3,0,0,0,.124.064A.568.568,0,0,0-.682,3.824ZM.038-7.917l4.329-2.438-9.657-5.489-3.7,2.084a3.037,3.037,0,0,0-.58.419Zm5.833-3.276,3.781-2.148a3.037,3.037,0,0,0-.58-.419L1.928-17.8a3.821,3.821,0,0,0-1.88-.537,3.839,3.839,0,0,0-1.891.537l-2,1.128Z",
    transform: "translate(10.318 18.337)",
    fill: "#333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestItem);
export default __webpack_public_path__ + "static/media/request-item.847fbabf94072a2faa030b792caafe73.svg";
export { ForwardRef as ReactComponent };